import _classCallCheck from "D:/workspace/js/hotfix/sunway-web-ui/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "D:/workspace/js/hotfix/sunway-web-ui/node_modules/@babel/runtime/helpers/esm/createClass";
import "core-js/modules/es.regexp.constructor.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.array.join.js";

/* eslint-disable no-control-regex */
import Gikam from 'gikam';

var _default = /*#__PURE__*/function () {
  function _default() {
    _classCallCheck(this, _default);
  }

  _createClass(_default, null, [{
    key: "validateSyntax",
    value: function validateSyntax(content) {
      var title = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '校验结果';

      if (typeof content !== 'string') {
        Gikam.error('校验内容仅支持字符串');
        return false;
      }

      var _content = removeNotes(content);

      return check(_content, title, new RegExp('[^\x00-\xff]', 'g'));
    }
  }]);

  return _default;
}(); //根据正则检查内容


export { _default as default };

function check(content, title, regExp) {
  var messageArr = [];
  content.split('\n').forEach(function (item, index) {
    var checkRes = item.replace(/".+"|'.+'/g, '').match(regExp);
    var i = index + 1;
    Gikam.isNotEmpty(checkRes) && messageArr.push(checkRes + '（第' + i + '行）');
  });
  return confirmResult(messageArr, title);
} //弹出内容提示


function confirmResult(messageArr, title) {
  if (Gikam.isEmpty(messageArr)) {
    return true;
  } else {
    Gikam.create('alert', {
      title: Gikam.propI18N(title),
      message: messageArr.join('<br/>')
    });
    return false;
  }
} //去除不校验的内容


function removeNotes(content) {
  //去掉单行注释
  var _content = content.replace(/\/\/.*(\r|\n|$)/g, '\n'); //去掉多行注释


  _content = _content.replace(/(?:^|\n|\r)\s*\/\*[\s\S]*?\*\/\s*(?:\r|\n|$)/g, function (i) {
    var str;
    i.split('\n').forEach(function (item, i) {
      i !== 0 && (str += '\n');
    });
    return str;
  });
  return _content;
}